import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api, fmtDateTime } from "@/lib/api";
import { PageHeader } from "@/components/Layout";
import { toast } from "sonner";
import { Bell, CheckCheck } from "lucide-react";

export default function Notifications() {
  const navigate = useNavigate();
  const [items, setItems] = useState([]);

  const load = () => api.get("/notifications").then((r) => setItems(r.data.items)).catch(() => {});
  useEffect(() => { load(); }, []);

  const readAll = async () => { await api.post("/notifications/read-all"); toast.success("All marked read"); load(); };
  const openN = async (n) => {
    if (!n.read) await api.patch(`/notifications/${n.id}/read`);
    if (n.link) navigate(n.link); else load();
  };

  return (
    <div className="max-w-2xl">
      <PageHeader eyebrow="Activity" title="Notifications">
        <button onClick={readAll} data-testid="read-all" className="panel flex items-center gap-1.5 px-3.5 py-2 rounded-sm text-xs text-[#C2BEB5] hover:border-[#C5A059] transition-colors shrink-0 whitespace-nowrap"><CheckCheck size={14} /> Mark all read</button>
      </PageHeader>
      <div className="panel rounded-sm overflow-hidden">
        <div className="divide-y" style={{ borderColor: "#28282D" }}>
          {items.length === 0 && <div className="px-4 py-12 text-center text-sm text-[#8C867A]">You're all caught up.</div>}
          {items.map((n) => (
            <button key={n.id} onClick={() => openN(n)} data-testid={`notif-${n.id}`}
              className={`w-full flex items-start gap-3 px-4 py-4 text-left hover:bg-[#1A1A1E] transition-colors ${n.read ? "opacity-60" : ""}`}>
              <div className="w-8 h-8 rounded-sm flex items-center justify-center shrink-0 mt-0.5" style={{ background: "#1A1A1E" }}>
                <Bell size={14} className={n.read ? "text-[#8C867A]" : "brass-text"} />
              </div>
              <div className="min-w-0 flex-1">
                <div className="flex items-center gap-2">
                  <span className="text-sm text-[#E2DFD7]">{n.title}</span>
                  {!n.read && <span className="w-1.5 h-1.5 rounded-full" style={{ background: "#D4AF37" }} />}
                </div>
                {n.body && <div className="text-xs text-[#8C867A] mt-0.5">{n.body}</div>}
                <div className="text-[0.6rem] text-[#5c5850] mt-1">{fmtDateTime(n.created_at)}</div>
              </div>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
